import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonService } from '@src/app/services/common.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { AddressNftHoldingV2 } from '@src/app/shared/types/address.type';
import { NzIconModule } from 'ng-zorro-antd/icon';
@Component({
    selector: 'app-collection-holdings',
    standalone: true,
    imports: [CommonModule, NzIconModule, RouterModule, ScrollingModule, SharedModule],
    templateUrl: './collection-holdings.component.html',
    styleUrls: ['./collection-holdings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionHoldingsComponent implements AfterViewInit, OnDestroy {
    @Input() collection: AddressNftHoldingV2;
    @ViewChild(CdkVirtualScrollViewport) viewport: CdkVirtualScrollViewport;

    private observer: IntersectionObserver;

    showLeftArrow = false;
    showRightArrow = true;

    constructor(public commonService: CommonService, private elementRef: ElementRef) {}

    ngAfterViewInit() {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.refreshView();
                }
            });
        });

        this.observer.observe(this.elementRef.nativeElement);
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    getTokenImg(tokenId: number | string) {
        return this.commonService.tokenImage(this.collection.chain_name, this.collection.token_address, tokenId);
    }

    errorHandler(e: any) {
        e.target.src = '/assets/imgs/fallback.png';
    }

    refreshView() {
        setTimeout(() => {
            if (this.viewport) {
                this.viewport.checkViewportSize();
            }
        });
    }
}
